import { render, staticRenderFns } from "./AutomatorTab.vue?vue&type=template&id=5eda76b2&scoped=true"
import script from "./AutomatorTab.vue?vue&type=script&lang=js"
export * from "./AutomatorTab.vue?vue&type=script&lang=js"
import style0 from "./AutomatorTab.vue?vue&type=style&index=0&id=5eda76b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eda76b2",
  null
  
)

export default component.exports